import React, { useState, useEffect } from "react"
import {
  CardBody,
  Container,
  Row,
  Col,
  Card,
  Input,
  Table,
  Modal,
  Button,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import ReactPaginate from "react-paginate"
import axios from "axios"
import { URLS } from "../../Url"
import { saveAs } from "file-saver"

function Complaintbox() {
  const [form1, setform1] = useState([])

  const [plans, setplans] = useState([])

  const [forms, setforms] = useState([])

  const [modal_small1, setmodal_small1] = useState(false)

  function tog_small1() {
    setmodal_small1(!modal_small1)
  }

  const getpopup1 = data => {
    setforms(data.description)
    tog_small1()
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const getPlans = () => {
    var token = datas
    axios
      .post(
        URLS.GetSupport,
        { status: "reject" },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setplans(res.data.data)
      })
  }

  const planssearch = e => {
    const myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)

    const token = datas

    axios
      .post(
        URLS.GetSupportSearch + `${e.target.value}`,
        { status: "reject" },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(
        res => {
          if (res.status === 200) {
            setplans(res?.data?.data)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  useEffect(() => {
    getPlans()
  }, [])

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = plans.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(plans.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  const downloadImage = url => {
    saveAs(url, url.split("/").pop())
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Home"
            breadcrumbItem="Rejected Support"
          />
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <div>
                    <div className="table-responsive">
                      <div style={{ float: "right" }}>
                        <Input
                          name="search"
                          value={form1.search}
                          onChange={planssearch}
                          type="search"
                          placeholder="Search..."
                        />
                      </div>
                      <Table className="table table-bordered mb-4 mt-5">
                        <thead>
                          <tr className="text-center">
                            <th>S.No</th>
                            <th>Ticket Id</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>User Name</th>
                            <th>User mobile</th>
                            <th>Title</th>
                            <th>Image</th>
                            <th>Description</th>
                            <th>Reply</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((data, key) => (
                            <tr key={key} className="text-center">
                              <th>{(pageNumber - 1) * 5 + key + 6}</th>
                              <td>{data.ticketId}</td>
                              <td>
                                {data.date}
                              </td>
                              <td>{data.time}</td>
                              <td>{data.userName}</td>
                              <td>{data.userMobile}</td>
                              <td>{data.reason} </td>
                              <td>
                                {/* <img
                                  style={{ width: "100px" }}
                                  src={URLS.Base + data.image}
                                /> */}
                                <div className="d-inline-block">
                                  <img
                                    style={{
                                      width: "100px",
                                      cursor: "pointer",
                                    }}
                                    src={URLS.Base + data.image}
                                    alt={`Template ${key}`}
                                    onClick={() =>
                                      downloadImage(URLS.Base + data.image)
                                    }
                                  />
                                  <i
                                    className="bx bx-download"
                                    style={{
                                      fontSize: "24px",
                                      color: "#007bff",
                                      marginLeft: "10px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      downloadImage(URLS.Base + data.image)
                                    }
                                  ></i>
                                </div>
                              </td>
                              <td>
                                {" "}
                                <Button
                                  outline
                                  color="warning"
                                  className="btn-sm"
                                  onClick={() => {
                                    getpopup1(data)
                                  }}
                                >
                                  <div className="d-flex">
                                    <small>View</small>
                                  </div>
                                </Button>
                              </td>
                              <td>{data.reply}</td>
                              <td>
                                <span className="badge bg-danger">
                                  {data.status}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal
          size="md"
          isOpen={modal_small1}
          toggle={() => {
            tog_small1()
          }}
          centered
        >
          <div className="modal-header">
            <h5 className="modal-title mt-0" id="mySmallModalLabel">
              View Description
            </h5>
            <button
              onClick={() => {
                setmodal_small1(false)
              }}
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">{forms}</div>
        </Modal>
        <ToastContainer />
      </div>
    </React.Fragment>
  )
}

export default Complaintbox
